
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.319","height":"10.151"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_29890","data-name":"Path 29890","d":"M4.103.989H3.019a1.167 1.167 0 00-1.116.824L.65 5.881a1.168 1.168 0 00-.052.343v2.16a1.168 1.168 0 001.168 1.168H9.55a1.168 1.168 0 001.168-1.168v-2.16a1.165 1.165 0 00-.052-.343l-1.25-4.068A1.168 1.168 0 008.3.989H7.216M.6 6.049h2a1.168 1.168 0 011.05.645l.133.266a1.168 1.168 0 001.045.646h1.67a1.168 1.168 0 001.041-.646l.133-.265a1.168 1.168 0 011.045-.646h2M5.659.6v4.281m0 0L4.103 3.324m1.556 1.557l1.557-1.557","fill":"none","stroke":"#727994","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}})])
          )
        }
      }
    